import { usePageVisibility } from 'react-page-visibility';

export default () => usePageVisibility();
